import styled from 'styled-components';

export const Title = styled.div`
	text-align: center;
	font-weight: 600;
`;
